<template>
  <!-- <v-container fill-height fluid> -->
  <v-layout justify-center column>
    <v-container class="pageContent">
      <v-layout column>
        <v-layout row wrap justify-space-around align-start>
          <v-flex xs12 style="text-align: center">
            <h1
              style="font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >
              Approved Suppliers
            </h1>
          </v-flex>
          <v-flex xs12 style="text-align: left;">
            <p>
              Our trustees have vetted and approved all these suppliers for
              quality and integrity, to ensure you're getting what you deserve.
            </p>
            <br />
          </v-flex>
        </v-layout>
      </v-layout>
      <v-sheet
        class="px-2 pt-2 pb-0"
        style="border:2px solid #4dc8ed;-webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;"
      >
        <v-layout>
          <v-flex xs6 class="mb-2">
            <div
              style="font-weight: bold !important; font-family: 'Aleo' !important; color: #4cc7e8; font-size: 1.2rem;"
            >
              Search by
            </div>
          </v-flex>
          <v-flex xs6 class="mb-2">
            <v-btn-toggle
              @change="filterList"
              style="width: 100% !important;"
              mandatory
              v-model="filter.searchBy"
            >
              <v-btn
                class="btn primary"
                style="width: 50%;"
                color="white"
                :small="$vuetify.breakpoint.xs"
                flat
                >Keyword</v-btn
              >
              <v-btn
                class="btn primary"
                style="width: 50%;"
                color="white"
                :small="$vuetify.breakpoint.xs"
                flat
                >Category</v-btn
              >
            </v-btn-toggle>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex
            v-if="services.length > 0 && filter.searchBy == 0"
            xs12
            class="pa-2"
          >
            <v-combobox
              ref="searchBox"
              v-model="filter.service"
              :items="services"
              label="Search by Service, Product or Business Name"
              prepend-inner-icon="mdi-magnify"
              @change="filterList()"
            />
          </v-flex>
          <v-flex v-if="filter.searchBy == 1" xs12 sm6 class="px-2">
            <v-btn
              class="my-1"
              outline
              round
              color="primary"
              style="font-size: 80%"
              block
              @click="
                filterBy = 'Category';
                filterDialog = true;
              "
              dark
            >
              <span style="font-weight: 700">Category</span>
              : {{ categoryBtnLabel() }}
              <v-chip
                v-if="this.filter.subCategory.length > 1"
                small
                color="primary"
                >+ {{ this.filter.subCategory.length - 1 }}</v-chip
              >
              <v-icon v-if="this.filter.category == '0'"
                >mdi-chevron-down</v-icon
              >
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="px-2">
            <v-btn
              class="my-1"
              outline
              round
              color="primary"
              block
              @click="
                filterBy = 'Location';
                filterDialog = true;
              "
              dark
            >
              <span style="font-weight: 700">Servicing</span>
              :
              {{ locationsBtnLabel() }}
              <v-chip
                v-if="this.filter.serviceDistricts.length > 1"
                small
                color="primary"
              >
                + {{ this.filter.serviceDistricts.length - 1 }}
              </v-chip>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <v-btn
              class="ma-0 mr-2 pa-0"
              color="primary"
              style="position: relative; float: right"
              flat
              small
              @click="clearFilter()"
              >Clear Search</v-btn
            >
          </v-flex>
        </v-layout>
      </v-sheet>
      <v-scale-transition>
        <v-progress-linear v-if="loadingResults" :indeterminate="true" />
      </v-scale-transition>
      <v-flex xs12 class="pa-2">
        <v-layout row wrap align-center></v-layout>
      </v-flex>
      <div
        v-if="businesses.length === 0 && loadingResults == false"
        class="subheading font-weight-thin mt-3"
      >
        No results found
      </div>
      <v-container v-else grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex
            v-for="business in businesses"
            :key="business.id"
            xs12
            sm6
            md4
            id="businessListingsSearch"
            class="businessListingsSearchHeight"
            style="height: 430px;"
          >
            <v-card
              @click="loadBusiness(business.id)"
              class="elevation-2"
              style="height: 100%;"
            >
              <v-img v-if="business.imageUrl" :src="business.imageUrl"></v-img>
              <v-img
                v-else
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/upstream-logo-padded.png?alt=media&token=748dcd0a-a617-4173-b33b-57aed67c4bc6"
                height="300px"
              >
                <v-tooltip v-if="business.locations != ''" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      style="position: absolute; bottom: 5px; right: 5px;"
                      color="primary"
                      dark
                      v-on="on"
                      >mdi-map-marker</v-icon
                    >
                  </template>
                  <span>{{ business.locations }}</span>
                </v-tooltip>
              </v-img>
              <v-card-title>
                <div>
                  <div class="title aboutWorkersName">
                    {{ business.listTitle }}
                    <span @click.stop="">
                      <v-tooltip v-if="business.locations != ''" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-map-marker</v-icon
                          >
                        </template>
                        <span style="font-weight: 700"
                          >Physical locations:</span
                        >
                        <p>{{ business.locations }}</p>
                      </v-tooltip>
                    </span>
                  </div>
                  <span class="aboutWorkersTitle">{{ business.name }}</span>
                </div>
              </v-card-title>
              <v-card-actions
                style="height:80px; position: absolute; bottom: 0px;"
              >
                <v-icon color="#ee1d23" style="font-size: 40px;"
                  >mdi-charity</v-icon
                >
                <div>
                  <p class="body-2 ml-1" style="margin-bottom: 0px;">
                    Charitable contribution
                  </p>
                  <p class="body-1 ml-1">
                    Contributing {{ business.contributionDetails }}
                  </p>
                </div>
                <br />
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="filterDialog"
      max-width="600"
    >
      <v-card height="100%">
        <v-toolbar dense color="primary" class="mb-0" dark>
          {{ filterBy }}
          <v-spacer></v-spacer>
          <v-btn color="primary" icon dark @click="filterDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout class="pa-1" row wrap>
            <v-flex v-if="filterBy == 'Category'" xs12 sm6 class="pa-1">
              <v-select
                v-model="filter.category"
                @change="filterList"
                :items="categories"
                item-text="name"
                item-value="id"
                label="Category"
              ></v-select>
            </v-flex>
            <v-flex v-if="filterBy == 'Category'" xs12 sm6 class="pa-1">
              <v-select
                v-model="filter.subCategory"
                @change="filterList"
                :disabled="filter.category == '0'"
                :items="categoriesByName[filter.category].children"
                label="Sub Category"
                item-text="name"
                item-value="id"
                multiple
                clearable
              ></v-select>
            </v-flex>

            <v-flex v-if="filterBy == 'Location'" xs12 sm6 class="pa-1">
              <v-select
                v-model="filter.serviceRegions"
                @change="filterList"
                :items="regions"
                label="Region"
              ></v-select>
            </v-flex>
            <v-flex v-if="filterBy == 'Location'" xs12 sm6 class="pa-1">
              <v-select
                v-model="filter.serviceDistricts"
                @change="filterList"
                :disabled="filter.serviceRegions == 'Nationwide'"
                :items="districtsByRegions[filter.serviceRegions]"
                label="District"
                multiple
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-btn
          v-if="$vuetify.breakpoint.xs"
          style="position: absolute; bottom: 5px; right: 5px;"
          round
          color="primary"
          dark
          @click="filterDialog = false"
        >
          <v-icon left>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loadingResults: true,
    filterDialog: false,
    filterBy: "",
    filter: {
      serviceRegions: "Nationwide",
      serviceDistricts: [],
      category: "0",
      subCategory: [],
      filterBy: ["Search", "Location"],
      searchBy: 0,
    },
    regions: [
      "Nationwide",
      "Auckland",
      "Bay Of Plenty",
      "Canterbury",
      "Gisborne",
      "Hawke's Bay",
      "Manawatu/Whanganui",
      "Marlborough",
      "Nelson/Tasman",
      "Northland",
      "Otago",
      "Southland",
      "Taranaki",
      "Waikato",
      "Wellington",
      "West Coast",
    ],
    districtsByRegions: {
      Nationwide: [],
      Northland: ["Far North", "Kaipara", "Whangarei"],
      Auckland: [
        "Auckland City",
        "Franklin",
        "Hauraki Gulf Islands",
        "Manukau City",
        "North Shore City",
        "Papakura",
        "Rodney",
        "Waiheke Island",
        "Waitakere City",
      ],
      Waikato: [
        "Hamilton",
        "Hauraki",
        "Matamata-Piako",
        "Otorohanga",
        "South Waikato",
        "Taupo",
        "Thames-Coromandel",
        "Waikato",
        "Waipa",
        "Waitomo",
      ],
      "Bay Of Plenty": [
        "Kawerau",
        "Opotiki",
        "Rotorua",
        "Tauranga",
        "Western Bay Of Plenty",
        "Whakatane",
      ],
      Gisborne: ["Gisborne"],
      "Hawke's Bay": ["Central Hawke's Bay", "Hastings", "Napier", "Wairoa"],
      Taranaki: ["New Plymouth", "South Taranaki", "Stratford"],
      "Manawatu/Whanganui": [
        "Horowhenua",
        "Manawatu",
        "Palmerston North",
        "Rangitikei",
        "Ruapehu",
        "Tararua",
        "Whanganui",
      ],
      Wellington: [
        "Carterton",
        "Kapiti Coast",
        "Lower Hutt",
        "Masterton",
        "Porirua",
        "South Wairarapa",
        "Upper Hutt",
        "Wellington",
      ],
      "Nelson/Tasman": ["Nelson", "Tasman"],
      Marlborough: ["Blenheim", "Kaikoura", "Marlborough"],
      "West Coast": ["Buller", "Grey", "Westland"],
      Canterbury: [
        "Ashburton",
        "Banks Peninsula",
        "Christchurch City",
        "Hurunui",
        "Mackenzie",
        "Selwyn",
        "Timaru",
        "Waimakariri",
        "Waimate",
      ],
      Otago: [
        "Central Otago",
        "Clutha",
        "Dunedin",
        "Queenstown-Lakes",
        "South Otago",
        "Waitaki",
        "Wanaka",
      ],
      Southland: ["Catlins", "Gore", "Invercargill", "Southland"],
    },
    districts: [],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      businesses: "business/filteredList",
      categories: "categories/listForFilter",
      categoriesByName: "categories/byName",
      services: "business/categoryServices",
      list: "business/list",
    }),
  },
  created() {
    if (this.$route.params.hasOwnProperty("category")) {
      this.filter.category = this.$route.params.category;
      this.filter.searchBy = 1;
    }
    if (this.$route.params.hasOwnProperty("service")) {
      this.filter.service = this.$route.params.service;
      this.filter.searchBy = 0;
    }
    this.$nextTick(function() {
      this.filterList();
    });
    this.$store.dispatch("business/loadAll");
    let nodes = document.querySelectorAll(
      "#LocationFilter_districtSelect > option"
    );
    let string = "";
    nodes.forEach((node) => (string = string + ', "' + node.innerHTML + '"'));
  },
  watch: {
    // categories: function(oldCat, newCat) {
    //   this.categories.unshift({ name: "All Categories" });
    //   this.$forceUpdate();
    // },
  },
  methods: {
    loadBusiness(businessId) {
      this.$store.dispatch("business/loadProfile", businessId);
      this.$router.push(`/business/${businessId}`);
    },
    filterList() {
      this.loadingResults = true;
      if (this.filter.category == "0") {
        this.filter.subCategory = [];
      }
      if (typeof this.$refs.searchBox != "undefined") {
        setTimeout(() => {
          this.$refs.searchBox.blur();
        }, 100);
      }

      this.$store.dispatch("business/filter", this.filter).then(() => {
        this.loadingResults = false;
      });
    },
    categoryBtnLabel() {
      let category = this.categories.find(
        (cat) => cat.id == this.filter.category
      );
      let label = `${category.name}`;

      if (this.filter.subCategory.length > 0) {
        let firstSubCategory = this.categoriesByName[
          this.filter.category
        ].children.find((subCat) => subCat.id == this.filter.subCategory[0]);
        label = `${firstSubCategory.name}`;
        // if (this.filter.subCategory.length > 1) {
        //   label += ` (+${this.filter.subCategory.length - 1})`;
        // }
      }

      return label;
    },
    locationsBtnLabel() {
      let label = `${this.filter.serviceRegions}`;
      if (this.filter.serviceDistricts.length > 0) {
        label = `${this.filter.serviceDistricts[0]}`;
      }
      return label;
    },
    clearFilter() {
      this.filter.serviceRegions = "Nationwide";
      this.filter.serviceDistricts = [];
      this.filter.category = "0";
      this.filter.subCategory = [];
      this.filter.filterBy = ["Search", "Location"];
      this.filter.service = "";
      this.filterList();
    },
  },
};
</script>

<style scoped>
.aboutWorkersName {
  font-weight: bold !important;
  font-family: "Aleo" !important;
  font-size: 15pt !important;
  color: #4cc7e8;
  margin-bottom: 0 !important;
}

.aboutWorkersTitle {
  font-weight: bold !important;
  font-family: "Aleo" !important;
  font-size: 12pt !important;
  color: #5a5a5c;
}

@media screen and (max-width: 1700px) {
  .businessListingsSearchHeight {
    height: 430px !important;
  }
}

@media screen and (max-width: 1264px) {
  .businessListingsSearchHeight {
    height: 410px !important;
  }
}

@media screen and (max-width: 960px) {
  .businessListingsSearchHeight {
    height: 450px !important;
  }
}

@media screen and (max-width: 600px) {
  .businessListingsSearchHeight {
    height: 520px !important;
  }
}

@media screen and (max-width: 510px) {
  .businessListingsSearchHeight {
    height: 450px !important;
  }
}

@media screen and (max-width: 410px) {
  .businessListingsSearchHeight {
    height: 420px !important;
  }
}

@media screen and (max-width: 310px) {
  .businessListingsSearchHeight {
    height: 330px !important;
  }
}

@media only screen and (max-width: 600px) {
  section#aboutSectionHeader {
    height: 100% !important;
  }
}

@media only screen and (min-width: 1904px) {
  .pageContent {
    max-width: 1200px;
  }
}
</style>
